module.exports = __webpack_public_path__ + "img/dots-blanc.7e8b9448.svg";